import { relationTypeToToken } from "@/helpers/relation-type";
import { normalizeTable } from "@/helpers/table-helper";

export class SchemaToDbml {
    tab = null
    content = '\n'

    constructor(tab) {
        this.tab = tab
    }

    async convert() {
        const settings = ((await import('../../stores/settings.store')).useSettingsStore)()
        const app = ((await import('../../stores/app.store')).useAppStore)()
        app.generatingDbmlModal = true
        for (const table of this.tab.schema.schema_data.tables) {
            const normalizedTable = normalizeTable(table)
            if (settings.settings.allowTableHexCode)
                this.content += `${normalizedTable.name} [color: ${normalizedTable.color}] {\n`
            else
                this.content += `${normalizedTable.name} {\n`

            for (const field of normalizedTable.fields) {
                this.content += await this.getFiledMl(field)
            }

            this.content += this.getIndexesMl(normalizedTable)
            this.content += this.getConstraintsMl(normalizedTable)

            this.content += `}\n\n`
        }

        this.content += this.getNotesMl()

        this.tab.dbml = this.content
        app.generatingDbmlModal = false
        return this.content
    }

    getNotesMl() {
        const notes = this.tab.schema?.schema_data?.notes || []
        if (!notes.length) return ''
        const usedNames = new Set(notes.map(n => n.name).filter(Boolean))
        let content = ''
        notes.forEach((note, idx) => {
            if (!note.name) {
                let candidate = `note_${idx + 1}`
                let i = idx + 1
                while (usedNames.has(candidate)) candidate = `note_${++i}`
                note.name = candidate
                usedNames.add(candidate)
            }
            const color = note.color || '#ffeb3a'
            content += `Note ${note.name} [color: ${color}] {\n`
            const body = (note.content ?? '').toString()
            const lines = body.length ? body.split('\n') : ['']
            for (const line of lines) content += `\t${line}\n`
            content += `}\n\n`
        })
        return content
    }

    async getFiledMl(field) {
        let content = `\t${field.name}`
        if (field.type) content += ` ${field.type}`
        if (field.size) content += `(${field.size})`

        if (field.pk) content += ` pk`
        if (field.allow_null) content += ` null`
        if (field.auto_increment) content += ` increments`
        if (field.unique) content += ` unique`
        if (field.default_value) content += ` def(${field.default_value})`
        if (field.fk) {
            const rel = relationTypeToToken(field.rel_type)
            content += ` ${rel} ${field.fk_table}.${field.fk_field}`
        }
        const settings = ((await import('../../stores/settings.store')).useSettingsStore)()
        if (settings.settings.allowFieldHexCode)
            if (field.color) content += ` ${field.color}`

        content += `\n`
        return content
    }

    getIndexesMl(table) {
        if (!table.indexes?.length) return ''

        let content = ''
        for (const index of table.indexes) {
            let line = `\t@index ${index.name || 'unnamed_index'}`
            if (index.columns) line += ` (${index.columns})`
            if (index.unique) line += ` unique`
            if (index.method) line += ` using ${index.method}`
            content += `${line}\n`
        }
        return content
    }

    getConstraintsMl(table) {
        if (!table.constraints?.length) return ''

        let content = ''
        for (const constraint of table.constraints) {
            let line = `\t@constraint ${constraint.name || 'unnamed_constraint'} ${constraint.type || 'custom'}`
            if (constraint.definition) line += ` ${constraint.definition}`
            content += `${line}\n`
        }
        return content
    }
}
